import React from 'react';

export interface IToastContext {
  open: boolean;
  type?: string;
  message?: string;
  showToast?: (type: string, message: string) => void;
  hideToast?: () => void;
}
export const ToastContext = React.createContext<IToastContext>({
  open: false,
});

export const ToastContextProvider = ToastContext.Provider;
